<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="blogShow">
    <NavBar />
    <div class="container">
      <div class="text-left mt-5 mb-2">
        <router-link :to="{ name: 'Blog' }" class="link"> &#60; Revenir à la liste des articles</router-link>
      </div>
      <div class="article">
        <img :src="article.main_image" class="w-100" :alt="article.main_image_alt_text" />
        <p class="date font-italic">{{ article.datetime_published }}</p>
        <h1>{{ article.title }}</h1>
        <vue-markdown :source="article.content" class="content text-left"></vue-markdown>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import ApiService from "@/services/ApiService";

import VueMarkdown from "vue-markdown";

function twDateLocale(d) {
  d = new Date(d);
  var options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
  d = d.toLocaleString("fr-FR", options).replace(/\b\w/, function (l) {
    return l.toUpperCase();
  });
  return d;
}

export default {
  name: "BlogShow",
  components: {
    NavBar,
    "vue-markdown": VueMarkdown
  },

  data() {
    return {
      article: []
    };
  },

  mounted() {
    ApiService.get("/articles/" + this.$route.params.id).then((response) => {
      this.article = response.data.article;
      this.article.datetime_published = twDateLocale(this.article.datetime_published);
    });
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
}
.blogShow {
  background-color: white;
  min-height: 100vh;
}

.container {
  max-width: 800px;
}

.article {
  padding: 0 10px 25px 10px;
}

.link {
  font-size: 1.1em;
}

.date {
  text-align: right;
  margin-top: 40px;
}

h1 {
  margin: 30px 0 40px 0 !important;
}

.card-img-top {
  background-color: $primary;
}
</style>
